export const CabinetInfo = [
  {
    name: "Nina Yu",
    pronouns: "she/her",
    position: "Chief Justice",
    major:
      "Public Health Studies, Social Policy Analysis, & Medical Humanities",
    img: "images/cabinet/2026-2027/nina-y.jpg",
    email: "jonescollegecourt@gmail.com",
    shortdesc:
      "Enforce the Alcohol Policy and Code of Conduct, appoint Associate Justices, preside over College Court cases",
    objpos: "0px -5px",
    maxsize: "160%",
  },
  {
    name: "Rachel Parr",
    pronouns: "she/her",
    position: "External Vice President",
    major: "Math and English (Creative Writing)",
    img: "images/cabinet/2026-2027/rachel.jpg",
    email: "jonesevp@gmail.com",
    shortdesc:
      "Coordinate Associates' Nights, organize other Associates and alumni events, appoint & chair Associates Committee",
    objpos: "0px -30px",
    maxsize: "210%",
  },
  {
    name: "Sawyer Rudy",
    pronouns: "he/him",
    position: "Internal Vice President",
    major: "Physics and Math ",
    img: "images/cabinet/2025-2026/sawyer.jpeg",
    email: "jonesvicepresident@gmail.com",
    shortdesc:
      "Oversee 9 appointed positions, coordinate Awards Night, Birthday Bash, Floor Olympics, and Talent Show",
    objpos: "0px 0px",
    maxsize: "150%",
  },
  {
    name: "Garrett Pirretti",
    pronouns: "he/him",
    position: " Senior Treasurer",
    major: "Chemical and Biomolecular Engineering",
    img: "images/cabinet/2025-2026/Garrett Pirretti.jpg",
    email: "jonescollegetreasurer@gmail.com",
    shortdesc: "Manage the Jones budget, maintain financial records",
    objpos: "0px 10px",
    maxsize: "150%",
  },
  {
    name: "Maya Iyengar",
    pronouns: "she/her",
    position: "Junior Treasurer",
    major: "Sport Management and Social Policy Analysis",
    img: "images/cabinet/2026-2027/maya-i.jpg",
    email: "jonescollegetreasurer@gmail.com",
    shortdesc: "Manage the Jones budget, maintain financial records",
    objpos: "0px -20px",
    maxsize: "180%",
  },
  {
    name: "Hannah Guo",
    pronouns: "she/her",
    position: "SA Senator",
    major: "English",
    img: "images/cabinet/2026-2027/hannah-g.jpeg",
    email: "jonessasentator@gmail.com",
    shortdesc:
      "Represent Jones in the Student Association, serve as a non-voting member of Cabinet",
    objpos: "0px 0px",
    maxsize: "170%",
  },
  {
    name: "Banesa Valencia ",
    pronouns: "she/her",
    position: "Senior DEI Coord",
    major: "Chemical and Biomolecular Engineering",
    img: "images/cabinet/2025-2026/banessa.jpeg",
    email: "jonesdei.council@gmail.com",
    shortdesc:
      "Creating and fostering a diverse, equitable, and inclusive environment at Jones through annual surveys, college-wide town hall forums, and trainings for all elected positions",
    objpos: "5px -5px",
    maxsize: "130%",
  },
  {
    name: "Zoë Márquez",
    pronouns: "she/her",
    position: "Junior DEI Coord",
    major: "Bioengineering (Pre-med track)",
    img: "images/cabinet/2026-2027/zoe-m.jpg",
    email: "jonesdei.council@gmail.com",
    shortdesc:
      "Creating and fostering a diverse, equitable, and inclusive environment at Jones through annual surveys, college-wide town hall forums, and trainings for all elected positions",
    objpos: "0px 0px",
    maxsize: "100%",
  },
  {
    name: "Julia Mickiewicz",
    pronouns: "she/her",
    position: "Secretary",
    major: "Global Affairs and Social Policy Analysis",
    img: "images/cabinet/2026-2027/julia-m.jpg",
    email: "jonessecretaries@gmail.com",
    shortdesc:
      "Manage the e-mail listserv, record & distribute Cabinet meeting minutes",
    objpos: "0px 0px",
    maxsize: "145%",
  },
  {
    name: "Lisa Wang",
    pronouns: "she/her",
    position: "Secretary",
    major: "Psychology and Cognitive Science",
    img: "images/cabinet/2026-2027/lisa-w.jpg",
    email: "jonessecretaries@gmail.com",
    shortdesc:
      "Manage the e-mail listserv, record & distribute Cabinet meeting minutes",
    objpos: "-10px -40px",
    maxsize: "250%",
  },
  {
    name: "Elizabeth Perry",
    pronouns: "she/her",
    position: "Parliamentarian",
    major: "Political Science",
    img: "images/cabinet/2026-2027/elizabeth-p.PNG",
    email: "jonesparliamentarian@gmail.com",
    shortdesc:
      "Maintain the Jones Constitution, count votes, and serve as a non-voting member of Cabinet",
    objpos: "0px 0px",
    maxsize: "150%",
  },
];
